<template>
    <div
        :class="[
            type ? 'app-tag--' + type : '',
            tagSize ? 'app-tag--' + tagSize : '',
            closable ? 'closable' : ''
        ]"
        class="app-tag">
        <span v-if="$slots.default">
            <slot/>
        </span>
        <div v-if="closable" class="app-tag--action" @click="$emit('close')">
            <i class="icon icon-close"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'app-tag',
    props: {
        type: {
            type: String,
            default: 'default'
        },
        size: String,
        closable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        tagSize() {
            return this.size
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.app-tag
    display: inline-block
    line-height: 1
    white-space: nowrap
    background: transparent
    border: 1px solid $dark-blue
    color: $dark-blue
    -webkit-appearance: none
    text-align: center
    box-sizing: border-box
    outline: 0
    margin: 0
    transition: 0.1s
    font-weight: 700
    padding: 10px 20px
    font-size: 13px
    border-radius: 19px
    justify-content: center
    align-items: center
    position: relative

    &.closable
        display: inline-flex
        padding-right: 30px

    .app-tag--action
        position: absolute
        right: 8px
        padding: 2px
        height: 18px
        color: $dark-blue
        cursor: pointer
        transition: all 0.1s ease-in
        border-radius: 15px

        &:hover
            background: $dark-blue
            color: $white

    &.app-tag--success
        border-color: #00AA02
        color: #00AA02

    &.app-tag--danger
        border-color: $red
        color: $red

    &.app-tag--small
        padding: 6px 14px
        border-radius: 15px
        font-size: 14px

        &.closable
            display: inline-flex
            padding-right: 25px

        .app-tag--action
            right: 4px

    &.app-tag--tiny
        padding: 5px 10px
        border-radius: 15px
        font-size: 11.5px
        font-weight: 500
</style>